import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { ChangePasswordModalComponent } from '../modals/change-password-modal/change-password-modal.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [DialogService],
  encapsulation: ViewEncapsulation.None
})
export class NavbarComponent implements OnInit, OnDestroy {
  public budgetPermission: boolean;
  public items: MenuItem[] | undefined;
  public logo: string = `./assets/img/brand/${environment.company}_black.svg`;
  private readonly languageSubscription: Subscription;
  private ref: DynamicDialogRef | undefined;
  public userName: string;

  constructor(private authenticationService: AuthenticationService, private translate: TranslateService,
    private router: Router, public dialogService: DialogService, private logger: NGXLogger) {
    this.languageSubscription = this.translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
          this.items = this.buildMenu();
      },
    );
  }

  // function to go to dashboard
  public goHome(): void {
    this.router.navigate([environment.routePath, 'dashboard']);
  }

  // function to go to prices table
  public prices(): void {
    this.router.navigate([environment.routePath, 'works']);
  }

  // function to log out
  public logout(): void {
    this.authenticationService.logout();
  }

  // function to open change password modal
  private changePassword(): void {
    this.ref = this.dialogService.open(ChangePasswordModalComponent, {
      header: this.translate.instant('change-password-modal.title'),
      width: '400px',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      maximizable: false,
      data: {}
    });

    this.ref.onClose.subscribe((result: any) => {
      this.logger.debug('change password modal close result: ', result);
    });
  }

  // function to build menu items for navbar user icon
  private buildMenu(): MenuItem[] {
    return [
      {
        label: this.translate.instant('holidays.title'),
        icon: 'pi pi-fw pi-send',
        routerLink: [environment.routePath, 'holidays'],
        visible: _.includes(environment.menu, 'holidays'),
      },
      {
        label: this.translate.instant('timesheet.title'),
        icon: 'pi pi-fw pi-clock',
        routerLink: [environment.routePath, 'timesheet'],
        visible: _.includes(environment.menu, 'timesheet'),
      },
      {
        label: this.translate.instant('budgets.title'),
        icon: 'pi pi-fw pi-table',
        routerLink: [environment.routePath, 'budgets'],
        visible: _.includes(environment.menu, 'budgets'),
      },
      {
        label: this.translate.instant('change-password-modal.title'),
        icon: 'pi pi-fw pi-lock',
        command: () => {
          this.changePassword();
        }
      }
    ];
  }

  ngOnInit(): void {
    this.userName = _.get(this.authenticationService.getUser(), 'name', this.translate.instant('_.user'));
    this.items = this.buildMenu();
    this.budgetPermission = _.includes(environment.menu, 'budgets');
  }

  ngOnDestroy() {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }
}
